import _asyncToGenerator from "/www/wwwroot/shishai_admin_fe/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _createForOfIteratorHelper from "/www/wwwroot/shishai_admin_fe/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _objectSpread from "/www/wwwroot/shishai_admin_fe/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/web.dom-collections.for-each.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import Breadcrumb from '@/components/Breadcrumb';
import Hamburger from '@/components/Hamburger';
import ErrorLog from '@/components/ErrorLog';
import Screenfull from '@/components/Screenfull';
import SizeSelect from '@/components/SizeSelect';
import Search from '@/components/HeaderSearch';
import request from "../../utils/request";
export default {
  components: {
    Breadcrumb: Breadcrumb,
    Hamburger: Hamburger,
    ErrorLog: ErrorLog,
    Screenfull: Screenfull,
    SizeSelect: SizeSelect,
    Search: Search
  },
  computed: _objectSpread({}, mapGetters(['sidebar', 'avatar', 'device', 'username', 'nickname', 'mobile', 'department', "userid", 'plan_id', 'institution', 'roles'])),
  data: function data() {
    return {
      planArr: [],
      plan: 0,
      urlR: ''
    };
  },
  mounted: function mounted() {
    this.plan = this.plan_id;
    this.getPlanListAll();

    if (this.roles.length > 0) {
      var _iterator = _createForOfIteratorHelper(this.roles),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;

          if (item != '') {
            this.urlR = item;
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    } else if (this.userid == 1) {
      this.urlR = '/';
    }
  },
  methods: {
    changePlan: function changePlan(e) {
      var _this = this;

      if (e > 0) {
        request({
          url: "admin/AdminUser/plan",
          method: "post",
          data: {
            admin_user_id: this.userid,
            plan_id: this.plan
          }
        }).then(function (res) {
          if (res.code == 200) {
            _this.$message.success(res.msg);

            location.reload();
          }
        }).catch(function (err) {});
      }
    },
    getPlanListAll: function getPlanListAll() {
      var _this2 = this;

      var age = 'all';

      if (this.institution.type == 'manage' || this.institution.type == 'hospital') {
        age = 'all';
      }

      if (this.institution.type == 'nursery') {
        age = '06';
      }

      if (this.institution.type == 'school') {
        age = '718';
      }

      request({
        url: "admin/ScreeningPlan/institutionList",
        method: "get",
        params: {
          page: 1,
          limit: 99999,
          age: age,
          dt: 1
        }
      }).then(function (res) {
        if (res.code == 200) {
          _this2.planArr = res.data;

          if (!_this2.plan_id) {
            // console.log('go')
            _this2.plan = res.data[0].id;

            _this2.changePlan(_this2.plan);
          } else {
            _this2.check_plan();
          }
        }
      }).catch(function (err) {});
    },
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar');
    },
    logout: function logout() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this3.$store.dispatch('user/logout');

              case 2:
                // this.$router.push(`/login?redirect=${this.$route.fullPath}`)
                window.location.reload();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    check_plan: function check_plan() {
      var _this4 = this;

      var i = 0;
      var oneid = this.planArr[0].id;
      this.planArr.forEach(function (e) {
        if (e.id == _this4.plan_id) {
          i = 1;
        }
      });

      if (i == 0) {
        request({
          url: "admin/ScreeningPlan/check_plan",
          method: "get",
          params: {
            id: oneid
          }
        }).then(function (res) {
          if (res.code == 200) {
            _this4.plan = oneid;

            _this4.$store.dispatch("user/setPlanId", oneid).then(function (res) {
              if (res == "ok") {// this.$message.success("操作成功");
              } else {// this.dialogVisible = false;
                // this.$message.error("操作失败");
              }
            });
          }
        }).catch(function (err) {});
      }
    }
  }
};